itsoftApp.createModule("lazyLoading", ["windowResize", "windowScroll"], function () {
    const module = this;
    window.lazyQueue = [];
    window.lazyInitQueue = function () {
        if (!window.lazyQueue.length) {
            return;
        }

        while (window.lazyQueue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            window.lazyQueue.shift()();
        }
    }

    window.lazyFunctions = {
        slider: function (element) {
            let sliderSettingsKey = element.getAttribute("data-slider-settings"); // получаем data-атрибут
            const sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

            if (sliderSettingsKey && sliderSettingsObject) {
                new itsoftApp.modules.slidersLibrary.callback(element, sliderSettingsObject);
            } else {
                new itsoftApp.modules.slidersLibrary.callback(element);
            }
        },
        scrollTrigger: function (element) {
            itsoftApp.modules.scrollActions.callback(element, true, false);
        },
        accordion: function (element) {
            new itsoftApp.modules.accordion.callback(element);
        },
        loadSection: function (element) {
            itsoftApp.modules.loadItems.initLoad(element);
        },
        videoInView: function (element) {
            itsoftApp.modules.videoInView.play(element);
        },
        animateTitle: function (element) {
            if (element.hasAttribute('data-delay')) {
                setTimeout(() => {
                    new itsoftApp.modules.animateTitle.callback(element); 
                }, element.dataset.delay);
            } else {
                new itsoftApp.modules.animateTitle.callback(element); 
            }
        },
    };

    function executeLazyFunction(element) {
        var lazyFunctionName;
        if (element.classList.contains('js-animate-title')) {
            lazyFunctionName = 'animateTitle';
        } else {
            var lazyFunctionName = element.getAttribute("data-lazy-function");
        }
        var lazyFunction = window.lazyFunctions[lazyFunctionName];
        if (!lazyFunction) return;
        lazyFunction(element);
    }

    const Lazy = function () {
        this.path = "/assets/scripts/vanilla-lazyload/lazyload.min.js";

        this.init();
    };

    /* Все наблюдатели — чтобы после подмены контента страницы без
       перезагрузки (chooseProduct.js) подхватить новые элементы: update() */
    const instances = [];

    const observe = function (settings) {
        const instance = new LazyLoad(settings); // eslint-disable-line

        instances.push(instance);

        return instance;
    };

    module.refresh = function () {
        instances.forEach(function (instance) {
            instance.update();
        });
    };

    Lazy.prototype.setSettings = function () {
        window.ll = observe({ // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".lazy, .lazyload", // eslint-disable-line
            class_loaded: "loaded", // eslint-disable-line,
            class_entered: "entered" // eslint-disable-line,
        });

        window.llCallback = observe({ // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".lazy-script, .js-script", // eslint-disable-line
            class_entered: "js-script-entered", // eslint-disable-line,
            callback_enter: executeLazyFunction
        });

        observe({ // eslint-disable-line
            threshold: -150, // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".js-anim", // eslint-disable-line
            class_entered: "js-anim--show" // eslint-disable-line,
        });

        observe({ // eslint-disable-line
            threshold: -150, // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".js-animate-title", // eslint-disable-line
            callback_enter: executeLazyFunction
        });

        // Ролики секций (/cartilox-t/): старт, когда блок уже на экране —
        // у общего .js-script порог по умолчанию +300px, и одноразовый ролик
        // начинал играть ещё за кадром
        observe({ // eslint-disable-line
            threshold: -150, // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".js-video-in-view", // eslint-disable-line
            callback_enter: executeLazyFunction
        });

        // Заголовки первого экрана: с порогом -150 заголовок, который весь
        // лежит выше 150px от верха окна (hero на 320: 56..138), не
        // появляется никогда. Здесь порога нет; второй запуск из общего
        // наблюдателя гасит проверка в animateTitle
        observe({ // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".js-animate-title-now", // eslint-disable-line
            callback_enter: executeLazyFunction
        });
    };

    Lazy.prototype.init = function () {
        itsoftApp.loadScript(this.path, this.setSettings);
    };

    new Lazy();
    module.callback = Lazy;
});
